{
  "Clear search": "Slet søgning"
}
